export default __webpack_public_path__ + "assets/images/cb2bd3364b7a8476965f803e006b1294.svg";